import { NgModule } from '@angular/core';
import { LayoutModule } from './components/layout/layout.module';
import { SlugifyPipe } from './pipes/slugify.pipe';
import { LoadingOrErrorComponent } from './components/loading-or-error/loading-or-error.component';
import { CommonModule } from '@angular/common';
import { FilterMarkUpPipe } from './pipes/filter-mark-up.pipe';
import { RemoveStoryTitlePipe } from './pipes/remove-story-title.pipe';
import { LoadingComponent } from './components/loading/loading.component';
import { FilterStoriesByTagsPipe } from './pipes/filter-stories-by-tags.pipe';
import { UserHeaderComponent } from './components/user-header/user-header.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { StoryHeaderComponent } from './components/story-header/story-header.component';
import { DateAgoPipe } from './pipes/date-ago.pipe';
import { FirestoreDocPipe } from './pipes/firestore-doc.pipe';
import { UserPhotoComponent } from './components/user-photo/user-photo.component';
import { HeadlineComponent } from './components/headline/headline.component';
import { CapitalizeFirstLetterPipe } from './pipes/capitalize-first-letter.pipe';
import { FilterStoriesByTypePipe } from './pipes/filter-stories-by-type.pipe';
import { FilterStoriesByStatusPipe } from './pipes/filter-stories-by-status.pipe';
import { SafePipe } from "./pipes/safe.pipe";

const PIPES = [
  SlugifyPipe, FilterMarkUpPipe, RemoveStoryTitlePipe,
  FilterStoriesByTagsPipe, DateAgoPipe, FirestoreDocPipe,
  CapitalizeFirstLetterPipe, FilterStoriesByTypePipe,
  FilterStoriesByStatusPipe, SafePipe
];
const DIRECTIVES = []!;

const COMPONENTS = [
  LoadingComponent, LoadingOrErrorComponent,
  StoryHeaderComponent,
  UserHeaderComponent, UserPhotoComponent,
  HeadlineComponent
];

@NgModule({
  providers: [...PIPES],
  imports: [
    LayoutModule, CommonModule, RouterModule,
    MatButtonModule, MatIconModule, MatMenuModule // UserHeaderComponent
  ],
  declarations: [...COMPONENTS, ...PIPES, ...DIRECTIVES],
  exports: [...COMPONENTS, ...PIPES, ...DIRECTIVES]
})
export class SharedModule {}
